// extracted by mini-css-extract-plugin
export default {"featured_container":"Featured_featured_container__pn4t-","artist_name":"Featured_artist_name__atYQD","artist_name_wrapper":"Featured_artist_name_wrapper__Dylqu"};